module.exports = __webpack_public_path__ + "static/works-001-508c223da20165b9b804102745d43a36.jpg";